import { TutorStatuses } from "./TutorStatuses";

export const TutorStatusesLabels = {
  [TutorStatuses.ACTIVE]: "Active",
  [TutorStatuses.ARCHIVED]: "Archived",
  [TutorStatuses.INACTIVE]: "Inactive"
};
